export default __webpack_public_path__ + "static/media/etfImg.abd7d18f.webp";